import { defaultCompanySettings, getCurrentCompanySettings, } from '@innovyze/stylovyze/lib/utils/companySettings';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import UnitsProvider from '@innovyze/stylovyze/lib/contexts/Settings/Units';
import { selectAuthenticationContext } from '@innovyze/stylovyze/lib/selectors';
import { setSettings as setSettingsAction } from '@innovyze/stylovyze/lib/actions/app.actions';
import { useGlobalization } from '../GlobalizationProvider/useGlobalization';
import { updateWhatsNewState } from '@innovyze/stylovyze/lib/actions';
import { useGetCurrentApp } from '@innovyze/stylovyze/lib/hooks/useGetCurrentApp';
export const SettingsContext = React.createContext({
    companySettings: defaultCompanySettings,
    settingsLoaded: false,
    setSettings: () => undefined,
});
export const useSettings = () => useContext(SettingsContext);
/**
 * Company Settings provider
 *
 * Falls back to US defaults
 */
export const SettingsProvider = ({ children, }) => {
    const dispatch = useDispatch();
    const [settingsLoaded, setSettingsLoaded] = useState(false);
    const [companySettings, setCompanySettings] = useState(defaultCompanySettings);
    const { i18n } = useGlobalization();
    const { isInitializing, defaultSite } = useSelector(selectAuthenticationContext);
    const shouldLoadSettings = !isInitializing && !settingsLoaded;
    // update settings in SettingsContext and redux store
    const setSettings = (settings) => {
        setCompanySettings(oldSettings => ({ ...oldSettings, ...settings }));
        dispatch(setSettingsAction({ companySettings: settings }));
    };
    const currentApp = useGetCurrentApp();
    useEffect(() => {
        if (shouldLoadSettings && defaultSite) {
            getCurrentCompanySettings(currentApp)
                .then(({ companySettings, lastWhatsNewVersionSeen }) => {
                setCompanySettings(companySettings);
                dispatch(setSettingsAction({ companySettings }));
                setSettingsLoaded(true);
                i18n.changeLanguage(companySettings.language);
                dispatch(updateWhatsNewState({
                    lastWhatsNewVersionSeen,
                    isLoading: false,
                }));
            })
                .catch(() => {
                const newCompanySettings = {
                    ...defaultCompanySettings,
                    organization: defaultSite,
                };
                setCompanySettings(newCompanySettings);
                dispatch(setSettingsAction({
                    companySettings: newCompanySettings,
                }));
                setSettingsLoaded(true);
            });
        }
    }, [shouldLoadSettings, defaultSite, currentApp]);
    return (React.createElement(SettingsContext.Provider, { value: { companySettings, settingsLoaded, setSettings } },
        React.createElement(UnitsProvider, { system: companySettings.UOM }, children)));
};
export default SettingsProvider;
